
import { Options, Vue } from 'vue-class-component'
import EvidenceSelector from '@/components/EvidenceSelector.vue'
import EvidenceProbability from '@/components/EvidenceProbability.vue'
import GhostPossibilities from '@/components/GhostPossibilities.vue'
import EvidenceTypes from '@/data/Evidence'
import Ghosts from '@/data/Ghosts'

@Options({
  components: { EvidenceSelector, EvidenceProbability, GhostPossibilities }
})

export default class Home extends Vue {
  evidenceTypes = EvidenceTypes
  evidence: string[] = []

  get possibleGhosts() {
    const evidence = this.evidence.filter(value => !!value)
    const possibilities = []

    for (let i = 0; i < Ghosts.length; i++) {
      const ghost = Ghosts[i]

      if (evidence.every(evidence => ghost.evidence.includes(evidence))) {
        possibilities.push(ghost)
      }
    }

    return possibilities
  }
}
